import React, { forwardRef } from 'react';
import { ButtonBase, Chip, styled } from '@mui/material';
import clsx from 'clsx';
import { tagClasses, getStyle } from './style';
import { IconClose } from '../../internal/icons';
import { useTranslation } from '../../hooks/useTranslation';
import { Avatar } from '../../Avatar';
const TagBase = forwardRef((props, ref) => {
    const { className, sx, style, label, disabled, onClose, onClick, closeButtonProps, avatar, status, ...otherProps } = props;
    const { t } = useTranslation('Tag');
    const clickable = !!onClick;
    const closable = Boolean(onClose) && !disabled;
    const error = status === 'error';
    return (React.createElement(Chip, { classes: tagClasses, className: clsx(tagClasses.root, className, {
            [tagClasses.clickable]: clickable,
            [tagClasses.error]: error,
        }), style: style, sx: sx, icon: avatar ? (React.createElement(Avatar, { size: "extraSmall", tabIndex: -1, ...avatar, className: tagClasses.avatar })) : (otherProps.icon), label: React.createElement("span", { "aria-hidden": true }, label), component: "div", tabIndex: clickable ? 0 : -1, "aria-disabled": disabled, "aria-invalid": error, role: clickable ? 'button' : 'presentation', onDelete: onClose, disabled: disabled, onClick: onClick, "aria-label": typeof label === 'string' ? label : undefined, deleteIcon: React.createElement(ButtonBase, { component: "div", disableRipple: true, tabIndex: closable && !disabled ? 0 : -1, "aria-label": typeof label === 'string' ? t('remove', { label }) : undefined, ...closeButtonProps },
            React.createElement(IconClose, { "aria-hidden": true, size: 14 })), ...otherProps, ref: ref }));
});
const Tag = styled(TagBase, {
    shouldForwardProp: (props) => props !== 'showShadow',
})((props) => {
    const { theme } = props;
    return getStyle(theme);
});
export default Tag;
